module.exports = __webpack_public_path__ + "static/img/third1_7_active.b5a43e99.jpg";